import axios from "axios";
import { lang } from "./Lang";
import { isFeatureEnabled } from "./Features";
import {
    mockDeleteBasketConfiguration,
    mockGetBasketConfiguration,
    mockGetBasketConfigurations,
    mockSaveBasketConfiguration,
    mockUpdateBasketConfiguration,
} from "./basketConfigurationStorage";

export const BASE_URL = window.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
export const REACT_APP_SHOP_API_URL = window.REACT_APP_SHOP_API_URL || process.env.REACT_APP_SHOP_API_URL;
export const AR_ENDPOINT = process.env.REACT_APP_AR_ENDPOINT;

/**
 * MYB-121 basket configuration. The real endpoints live on the Content Hub API
 * and are not implemented yet. Modes:
 *  - "mock" (default): only the localStorage mock is used
 *  - "live": only the real Content Hub endpoints are used
 *  - "auto": real endpoint first, localStorage mock fallback on error
 */
export const BASKET_API_MODE = String(
    window.REACT_APP_BASKET_API_MODE || process.env.REACT_APP_BASKET_API_MODE || 'mock'
).toLowerCase();

function getLangCode() { return lang.current || 'pl'; }

function logBasketApi(action, payload) {
    console.log(`[basketConfig:api] ${action}`, payload ?? '');
}

function useMock() {
    return BASKET_API_MODE === 'mock';
}

function useFallback() {
    return BASKET_API_MODE === 'auto';
}

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
});
const shopApi = axios.create({
    baseURL: REACT_APP_SHOP_API_URL,
    timeout: 60000,
});


export async function createAr(json){

    return api.request({
        method: "post", 
        url: AR_ENDPOINT, 
        data: json, 
        headers: {
            'Content-Type': 'application/json'
        }
    });    
}

export async function getProduct(id){

    
    // return api.request({
    //     method: "get",
    //     url: ``,
    //     data: {
    //         "product_id": id
    //     },
    //     headers: {
    //         'Content-Type': 'application/json'
    //     }
    // });

    // return new Promise((resolve, reject) => {
    
    //     setTimeout(() => {
    //         resolve(product);
    //     }, 555);
    // });

    console.log({ BASE_URL, id });
    return fetch(`${BASE_URL}?lang=${getLangCode()}`, {
        method: "POST",
        body: JSON.stringify({
            product_id: id,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    }).then((res) => res.json());
}


export async function saveProject(data){
    return api.request({
        method: "post",
        url: BASE_URL + '/save-configuration',
        params: { lang: getLangCode() },
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
export async function savePdf(data){
    return shopApi.request({
        method: "post",
        url:  '/configurator-api/pdf',
        params: { lang: getLangCode() },
        data: JSON.stringify(data),
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
export async function sendEmail(data){
    return shopApi.request({
        method: "post",
        url: '/configurator-api/send',
        params: { lang: getLangCode() },
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

// /{projectId}/{projectHash}/configurator/{configuratorId}/update-configuration/{id}/{hash}
export async function updateProject(data){
    if(!data.id || !data.hash){
        console.error(data);
        throw new Error("Brak id lub hash");
    }
    let url = BASE_URL + `/update-configuration/${data.id}/${data.hash}`
    
    delete data.id;
    delete data.hash;

    return api.request({
        method: "post",
        url: url,
        params: { lang: getLangCode() },
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export async function getProject({id, hash}){
    return api.request({
        method: "get",
        url: BASE_URL + `/load-configuration/${id}/${hash}`,
        params: { lang: getLangCode() },
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

/**
 * MYB-121: persist a configuration together with the basket line items it
 * produced. Returns { status, id }.
 */
export async function saveBasketConfiguration(data){
    logBasketApi('save-basket', data);
    if(!isFeatureEnabled()){
        console.warn('[basketConfig:api] feature disabled, skipping save-basket');
        return { status: false, disabled: true };
    }
    if(useMock()){
        return mockSaveBasketConfiguration(data);
    }
    try {
        const response = await api.request({
            method: "post",
            url: BASE_URL + '/save-basket',
            params: { lang: getLangCode() },
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        if(useFallback()){
            console.warn('[basketConfig:api] save-basket failed, falling back to mock', err);
            return mockSaveBasketConfiguration(data);
        }
        throw err;
    }
}

/**
 * MYB-121: update an existing basket configuration and replace its line items.
 * Expects `id`, `configuration`, `basketItems` and `previousBasketItems`.
 */
export async function updateBasketConfiguration(data){
    logBasketApi('update-basket', data);
    if(!isFeatureEnabled()){
        console.warn('[basketConfig:api] feature disabled, skipping update-basket');
        return { status: false, disabled: true };
    }
    if(!data?.id){
        throw new Error('Brak id konfiguracji koszyka');
    }
    if(useMock()){
        return mockUpdateBasketConfiguration(data);
    }
    try {
        const response = await api.request({
            method: "post",
            url: BASE_URL + '/update-basket',
            params: { lang: getLangCode() },
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        if(useFallback()){
            console.warn('[basketConfig:api] update-basket failed, falling back to mock', err);
            return mockUpdateBasketConfiguration(data);
        }
        throw err;
    }
}

/**
 * MYB-121: fetch a basket configuration (JSON) by its basket configuration id.
 */
export async function getBasketConfiguration(id){
    logBasketApi('load-basket', { id });
    if(!isFeatureEnabled()){
        console.warn('[basketConfig:api] feature disabled, skipping load-basket');
        return { status: false, disabled: true };
    }
    if(useMock()){
        return mockGetBasketConfiguration(id);
    }
    try {
        const response = await api.request({
            method: "get",
            url: BASE_URL + `/load-basket/${id}`,
            params: { lang: getLangCode() },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        if(useFallback()){
            console.warn('[basketConfig:api] load-basket failed, falling back to mock', err);
            return mockGetBasketConfiguration(id);
        }
        throw err;
    }
}

/**
 * MYB-121: resolve basket configurations for the given basket line item ids.
 * Used by the basket page to inject "Edit configuration" links.
 */
export async function getBasketConfigurations({ basketItemIds = [] } = {}){
    logBasketApi('basket-configurations', { basketItemIds });
    if(!isFeatureEnabled()){
        console.warn('[basketConfig:api] feature disabled, skipping basket-configurations');
        return { status: false, disabled: true, basketConfigurations: [] };
    }
    if(useMock()){
        return mockGetBasketConfigurations({ basketItemIds });
    }
    try {
        const response = await api.request({
            method: "post",
            url: BASE_URL + '/basket-configurations',
            params: { lang: getLangCode() },
            data: JSON.stringify({ basketItemIds }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        if(useFallback()){
            console.warn('[basketConfig:api] basket-configurations failed, falling back to mock', err);
            return mockGetBasketConfigurations({ basketItemIds });
        }
        throw err;
    }
}

/**
 * MYB-121: removes a basket configuration and its stored references. Used when
 * the main product is removed from the basket (its extra products are removed too).
 */
export async function deleteBasketConfiguration(id){
    logBasketApi('delete-basket', { id });
    if(!isFeatureEnabled()){
        console.warn('[basketConfig:api] feature disabled, skipping delete-basket');
        return { status: false, disabled: true };
    }
    if(!id){
        throw new Error('Brak id konfiguracji koszyka');
    }
    if(useMock()){
        return mockDeleteBasketConfiguration(id);
    }
    try {
        const response = await api.request({
            method: "delete",
            url: BASE_URL + `/delete-basket/${id}`,
            params: { lang: getLangCode() },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        if(useFallback()){
            console.warn('[basketConfig:api] delete-basket failed, falling back to mock', err);
            return mockDeleteBasketConfiguration(id);
        }
        throw err;
    }
}
